import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { useStore } from 'src/stores';
import { answered } from './asyncResult';

/** Whether the company has Bill Automation: null until known, then true or false. */
export const useBillAutomationEntitlement = companyId => {
  const store = useStore();
  // null = not yet known. Rendering the form before the answer arrives would let someone start
  // typing a password we are about to tell them we cannot accept.
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    entitled = _useState2[0],
    setEntitled = _useState2[1];
  useEffect(() => {
    if (!companyId) return undefined;
    let cancelled = false;
    // Back to unknown for every company. Without this an impersonating admin who switches company
    // keeps the previous tenant's answer whenever the new lookup fails, so one company's form or
    // "not on this plan" notice is shown against another's utility.
    setEntitled(null);
    store.admin.getUtilityCredentialEntitlementAsync.run(companyId).then(resp => {
      if (cancelled) return;
      // A failed OR superseded lookup is not "not entitled". run() resolves undefined rather
      // than rejecting, and a run cancelled by a later one leaves isError false, so neither
      // flag alone catches both. Without this an outage - or simply a second lookup starting -
      // renders "Bill automation is not on this plan" at a paying customer. `cancelled` does
      // not cover it: that only fires when THIS effect tears down, not when a concurrent run
      // supersedes this request. Leaving it null keeps the section neutral: no form, no notice.
      if (!answered(resp) || store.admin.getUtilityCredentialEntitlementAsync.isError) return;
      const data = (resp === null || resp === void 0 ? void 0 : resp.response) || resp;
      setEntitled(!!(data !== null && data !== void 0 && data.entitled));
    })
    // Fail CLOSED on a thrown error: we do not offer to take a password we cannot accept.
    .catch(() => {
      if (!cancelled) setEntitled(false);
    });
    return () => {
      cancelled = true;
    };
  }, [store, companyId]);
  return entitled;
};